import { getActiveContentTab, lazyCloseTab, TabType } from 'owa-tab-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags/lib/utils/isFeatureEnabled';

/**
 * Closes the active secondary reading pane tab, if one is active.
 * This is a no-op when called from the main window (no secondary tab active).
 */
export default function tryCloseSecondaryReadingPaneTab(): void {
    if (isGlobalFeatureEnabled('mon-ribbon-secondary-rp-activation')) {
        const activeTab = getActiveContentTab();
        if (activeTab?.type === TabType.SecondaryReadingPane) {
            lazyCloseTab.importAndExecute(activeTab);
        }
    }
}
